export default from './Social'



// WEBPACK FOOTER //
// ./app/components/Social/index.js